import { render } from "./UpdateApp.vue?vue&type=template&id=4fa0df32"
import script from "./UpdateApp.vue?vue&type=script&lang=js"
export * from "./UpdateApp.vue?vue&type=script&lang=js"
script.render = render

export default script